var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkMainCommentss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.74874 5.42627C8.43363 4.11116 6.30143 4.11116 4.98633 5.42627C3.67122 6.74137 3.67122 8.87357 4.98633 10.1887L6.53048 11.7328C6.92101 12.1233 6.92101 12.7565 6.53048 13.147C6.13996 13.5375 5.50679 13.5375 5.11627 13.147L3.57211 11.6029C1.47596 9.50674 1.47596 6.10821 3.57211 4.01205C5.66827 1.9159 9.0668 1.9159 11.163 4.01205L20.4279 13.2769C22.524 15.3731 22.524 18.7716 20.4279 20.8678C18.3317 22.9639 14.9332 22.9639 12.837 20.8678L9.3627 17.3934C7.90616 15.9369 7.90616 13.5754 9.3627 12.1188C10.8192 10.6623 13.1808 10.6623 14.6373 12.1188L16.5675 14.049C16.958 14.4396 16.958 15.0727 16.5675 15.4632C16.177 15.8538 15.5438 15.8538 15.1533 15.4632L13.2231 13.533C12.5476 12.8576 11.4524 12.8576 10.7769 13.533C10.1014 14.2085 10.1014 15.3037 10.7769 15.9792L14.2513 19.4536C15.5664 20.7687 17.6986 20.7687 19.0137 19.4536C20.3288 18.1385 20.3288 16.0063 19.0137 14.6912L9.74874 5.42627Z",
    fill: "#B3B3B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkMainCommentss);
export default __webpack_public_path__ + "static/media/link_main_commentss.730b5fbf1fcd3b6ad51d70895cbe6cff.svg";
export { ForwardRef as ReactComponent };